import {merge} from '#core/utils/config-utils.js';

import {generateInput} from '../input/index.js';

export function generateSearchInput(INPUT_TILE) {
    const SEARCH_INPUT = generateInput(INPUT_TILE);

    return {
        container: {
            base: {
                style: merge(SEARCH_INPUT.style.base, {
                    _mobile_width: '100%',
                    _mobile_maxWidth: '100%',
                    // move to client config if they are not the same
                    height: '32px',
                    _mobile_height: '40px',
                    minHeight: 'initial',
                }),
            },
            active: {
                createStackingContext: true,
                style: {
                    _desktop_width: '248px',
                },
            },
            inactive: {
                createStackingContext: true,
                style: {
                    _desktop_width: '160px',
                },
            },
        },
        textInput: {
            style: {
                base: {
                    padding: '0 8px',
                    fontSize: 'inherit',
                    fontWeight: 'inherit',
                    color: 'inherit',
                    backgroundColor: 'inherit',
                    backgroundImage: 'inherit',
                },
                placeholder: SEARCH_INPUT.style.placeholder,
            },
        },
        searchIconContainer: {
            style: {
                padding: '0',
            },
        },
        inactiveSearchIcon: {
            style: {
                fill: INPUT_TILE.INPUT_ICON_COLOR,
            },
        },
        activeSearchIcon: {
            style: {
                fill: INPUT_TILE.INPUT_FOCUSED_ICON_COLOR,
            },
        },
        spinnerContainer: {
            style: {
                minWidth: 'initial',
                minHeight: 'initial',
            },
        },
        spinner: {
            style: {
                container: {
                    minWidth: '16px',
                    minHeight: '16px',
                },
            },
            image: {
                style: {
                    fill: INPUT_TILE.INPUT_FOCUSED_ICON_COLOR,
                },
            },
        },
        clearButton: {
            style: {
                base: {
                    minWidth: 'initial',
                    minHeight: 'initial',
                    right: '0',
                },
            },
        },
        clearIcon: {
            style: {
                fill: INPUT_TILE.INPUT_FOCUSED_ICON_COLOR,
            },
        },
    };
}
